import './UsersList.scss'

import React, { Component } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import moment from 'moment-timezone'
import SearchInput from 'react-search-input'
import Select from 'react-select'
import { connect } from 'react-redux'
import { show as showModal } from 'redux-modal'

import Table from 'common/views/atoms/Table/Table'
import {editAgentMVIPEnabled, editAgentMVIPParticipant, editPendingExperienceLevel, fetchAddAgent} from 'broker/redux/account'
import { labelFor } from 'common/util/helper'
import {
  selectCompletedAgents,
  selectCompletedBrokerContacts,
  selectPendingAgents,
  selectPendingBrokerContacts,
  selectPendingCount,
  selectCompletedCount,
  selectHasTransitionProduct,
  selectIsMVIP,
  selectIsTransitionBrokerage,
  selectBrokerHash,
  selectAllowAgentSignUps,
} from 'broker/selectors/account'

import { selectAuthUser } from 'common/redux/selectors/auth'

import {AGENT_EXPERIENCE_LEVELS, BROKER_CONTACT_TYPES, BROKER_CONTACT_TYPES_DISPLAY} from 'common/constants'
import FeedbackCheckbox from "common/views/components/FeedbackCheckbox";
import EditAdminModal from "broker/views/components/ManageUsers/EditAdminModal";
import OpRadio from "common/views/components/OpRadio";
import toastr from "toastr";
class UsersList extends Component {
  BROKER_SUCCESS_TEAM_ID = 25
  SUPER_TEAM_ID = 9

  constructor(props) {
    super(props)
    const { completed_agents, completed_broker_contacts, pending_agents, pending_broker_contacts} = this.props
    let startOnAdded = completed_agents.length || completed_broker_contacts.length || !(pending_agents.length || pending_broker_contacts.length)
    this.state = {
        activeTab: startOnAdded ? 'added' : 'pending',
        search: ''
    }
  }

  resendInvite = invite => {
    const { dispatch } = this.props
    dispatch(showModal("ConfirmResendModal", {initialState: invite, dispatch }))
  }

  editInvite = invite => {
    const { dispatch } = this.props
    dispatch(showModal("EditInviteModal", { invite, dispatch }))
  }

  copyInviteLink = item => {
    const { invite_url } = item
    if(invite_url ) {
      navigator.clipboard.writeText(invite_url).then(() => {
        toastr.success('Unique agent invite link copied to clipboard')
      }
      )
    } else {
      toastr.error('An error occurred. Please try again.')
    }

  }

  cancelInvite = invite => {
    const { dispatch } = this.props
    dispatch(showModal("CancelInboundModal", { invite, dispatch }))
  }

  removeAgent = agent => {
    const { dispatch } = this.props
    dispatch(showModal("RemoveAgentModal", { agent, dispatch, can_remove: true}))
  }

  removeContact = contact => {
    const { dispatch } = this.props
    dispatch(showModal("ConfirmRemoveContactModal", {initialState: contact, dispatch }))
  }

  updateAndRemoveBrokerContact = (brokerContact ) => {
    const { dispatch, completed_broker_contacts, pending_broker_contacts, broker_hash} = this.props
    const contacts = this.state.activeTab === 'added' ? completed_broker_contacts : pending_broker_contacts
    dispatch(showModal("RemoveBrokerContactModal", {can_remove: this.props.user.is_masquerade, contact_to_remove: brokerContact, dispatch, contacts, broker_hash: broker_hash}))
  }

  handleEditAdmin = (brokerUser) => {
    const { dispatch , user} = this.props
    if(user.is_masquerade){
       dispatch(showModal("EditAdminModal", {brokerUser: brokerUser, dispatch: dispatch, user: user} ))
    }
  }

  handleExperienceChange = (item, value, resendInvite) => {
    const { dispatch } = this.props

    if (item.agent_experience_level === value) {
      return
    }

    dispatch(editPendingExperienceLevel(value, item.broker_invite_hash, item.broker_inbound_hash, item.email, resendInvite))
  }

  handleAgentExperienceChange = (agent, value) => {
    const { dispatch } = this.props
    if (value !== agent.agent_experience_level) {
      dispatch(
        showModal("ConfirmEditAgentExperienceModal", {
          agent_id: agent.id, agent_name: [agent.first_name, agent.last_name].join(' '), dispatch, agent_experience_level: value
        })
      )
    }
  }

  handleAdminRoleChange = (admin, value) => {
    const { dispatch } = this.props
    if (value !== admin.contact_type) {
      dispatch(
        showModal("ConfirmEditAdminRoleModal", {
            broker_user_id: admin.id, admin_name: [admin.first_name, admin.last_name].join(' '), dispatch, current_role: admin.contact_type, requested_role: value
          })
      )
    }
  }

  handleAgentMVIPParticipationChange = (agent, value) => {
    const { dispatch, is_transition_brokerage } = this.props
    if(agent.is_transition_enabled && this.getMVIPAgentCount() == 1 && is_transition_brokerage) {
      dispatch(showModal("RemoveAgentModal", { agent, dispatch, can_remove: false}))
    }
    if (value !== agent.is_mvip_participant) {
      dispatch(editAgentMVIPParticipant(value, agent.id))
    }
  }

  handleAgentMVIPChange = (agent, value) => {
    const { dispatch, is_transition_brokerage } = this.props
    if(agent.is_transition_enabled && this.getMVIPAgentCount() == 1 && is_transition_brokerage) {
      dispatch(showModal("RemoveAgentModal", { agent, dispatch, can_remove: false}))
    } else if (value !== agent.is_transition_enabled) {
      dispatch(editAgentMVIPEnabled(value, agent.id))
    }
  }

  getMVIPAgentCount() {
    let count = 0
    this.props.completed_agents.forEach(agent => {
      if(agent.is_mvip_participant) {
        count += 1
      }
    })
    return count
  }

  renderPendingRow(item, idx, isRCCOnly) {
    const { brokerAPMInviteExpirationEnabled, is_transition_brokerage, user  } = this.props
    let rowClassNames = ['UsersListRow', 'UsersList__row--' + idx % 4]

    let canResendExpiredInvite = is_transition_brokerage || (user && user.is_masquerade)
    let hideEditInviteButton = brokerAPMInviteExpirationEnabled && item.is_expired && !canResendExpiredInvite
    let showCopyUniqueLink = (!brokerAPMInviteExpirationEnabled || (brokerAPMInviteExpirationEnabled && !item.is_expired))

    if (!item.agent_experience_level) {
      const level = ["flagged", "failed-criteria"].includes(item.inbound_status) ? "emerging" : "experienced"
      item.agent_experience_level = level
      this.handleExperienceChange(item, level, false)
    }

    return <tr className={rowClassNames.join(' ')} key={idx}>
      <td>
        <UsersListAvatar {...item} />
      </td>
      {!isRCCOnly && <td className="UsersListRow__type">
        { item.agent_experience_level ? <Select
            value={item.agent_experience_level}
            clearable={false}
            backspaceRemoves={false}
            searchable={false}
            onChange={value => this.handleExperienceChange(item, value.value, true)}
            options={AGENT_EXPERIENCE_LEVELS}
        /> : <div>{ item.type }</div> }
      </td>}
      <td className="UsersListRow__drip-campaign">
          { brokerAPMInviteExpirationEnabled && item.is_expired ?
              <div className={'expiration-warning-content'}>
                <i className="fa fa-warning" style={{fontSize: 24}}/>
                <div className={"text"}>Invite expired</div>
              </div>
            :
            <div>
              { item.invited_at ? (item.is_successful_invite !== false ? <div>Invite Sent</div> : <div>Invalid email address, invite failed</div>) : <div>Pending</div> }
              { item.invited_at && (item.is_successful_invite !== false) ? <div>{moment.utc(item.invited_at).local().format("MM/DD/YY h:mm A")}</div> : null }
            </div>
          }

      </td>
      <td className="UsersListRow__actions">
        { item.broker_invite_hash ?
          (hideEditInviteButton ?
              <div className={'UsersListRow__actions--no-resend'}>This invite cannot be edited</div>
              :
            <Button className="UsersListRow__buttons--resend UsersListRow__buttons--edit"
                  onClick={()=>{this.editInvite(item)}}>
              Edit Invite
            </Button>
          )
           :
          <Button className="UsersListRow__buttons UsersListRow__buttons--danger"
                  onClick={()=>{this.cancelInvite(item)}}>
            Cancel Invite
          </Button>
        }

        {item.broker_invite_hash && showCopyUniqueLink ?
          <Button className="UsersListRow__buttons--copy-link" onClick={()=>{this.copyInviteLink(item)}}>
            Copy unique link
          </Button>
          : null
        }
      </td>
    </tr>
  }

  renderPendingContactRow(item, idx) {
    let rowClassNames = ['UsersListRow', 'UsersList__row--' + idx % 4]
    return <tr className={rowClassNames.join(' ')} key={idx}>
      <td>
        <UsersListAvatar {...item} />
      </td>
      <td className="UsersListRow__type">
          <div>{ BROKER_CONTACT_TYPES_DISPLAY[item.contact_type] }</div>
      </td>
      <td className="UsersListRow__status">
        <div>Invite sent</div>
        { item.sent_at ? <div>{moment.utc(item.sent_at).local().format("MM/DD/YY h:mm A")}</div> : null }
      </td>
      <td className="UsersListRow__actions">
        { item.hash ?
          <Button className="UsersListRow__buttons--resend UsersListRow__buttons--edit"
                  onClick={()=>{this.editInvite(item)}}>
            Edit Invite
          </Button> : null
        }
      </td>
    </tr>
  }

  renderCompletedRow(item, idx, hide_closes) {
    if (!item.agent_experience_level) {
      item.agent_experience_level = "experienced"
    }
    const { has_transition_product, is_mvip, user, allow_agent_sign_ups } = this.props
    const configuringMvip = has_transition_product || (is_mvip && allow_agent_sign_ups)
    const rowClassNames = ['UsersListRow', 'UsersList__row--' + idx % 4]
    const closeCopy = item.close_count === 1 ? 'Close' : 'Closes'
    const isSuper = user.team_id === this.SUPER_TEAM_ID
    const isBrokerSuccess = user.team_id === this.BROKER_SUCCESS_TEAM_ID
    const participantIsChecked = item.is_mvip_participant || item.is_transition_enabled

    return <tr className={rowClassNames.join(' ')} key={idx}>
      <td>
        <UsersListAvatar {...item} />
      </td>
      <td>
        { item.agent_experience_level ? <div>
          { (item.agent_experience_level === "experienced" && item.close_count < 3) || (isSuper || isBrokerSuccess)
            ? <Select
                value={item.agent_experience_level}
                clearable={false}
                backspaceRemoves={false}
                searchable={false}
                onChange={e => {
                  this.handleAgentExperienceChange(item, e.value)
                }}
                options={AGENT_EXPERIENCE_LEVELS}
              /> : <span className="ml-10">
              { labelFor(AGENT_EXPERIENCE_LEVELS, item.agent_experience_level) }
            </span>}
          </div>
          : <div>Agent</div> }
          { configuringMvip && (
              <div className={"ml-10 mt-10"}>
                <FeedbackCheckbox
                 label={"Market VIP Participant"}
                 checked={participantIsChecked}
                 onChange={e => this.handleAgentMVIPParticipationChange(item, e.target.checked)}
                 labelClass={!participantIsChecked ? "UsersList__disabled" : null}
                />

                {participantIsChecked && <OpRadio
                  divClass={"ml-25"}
                  label={"Receive MVIP Leads"}
                  checked={item.is_transition_enabled}
                  onChange={() => {
                    this.handleAgentMVIPChange(item, !item.is_transition_enabled)
                  }}
                />
                }
                {participantIsChecked && <OpRadio
                  divClass={"ml-25"}
                  label={"Pause MVIP Leads"}
                  checked={!item.is_transition_enabled}
                  onChange={() => {
                    this.handleAgentMVIPChange(item, !item.is_transition_enabled)
                  }}
                  />
                }
                </div>
          )
         }
      </td>
      {!hide_closes && (
        <td>{item.close_count} {closeCopy}</td>
      )}
      <td>
        <div>{ item.status }</div>
        <div>{moment.utc(item.completed_at).local().format("MM/DD/YY h:mm A")}</div>
      </td>
      <td className="UsersListRow__actions">
        <Button className="UsersListRow__buttons UsersListRow__buttons--danger"
                onClick={() => {this.removeAgent(item)}}>Terminate</Button>
      </td>
    </tr>
  }

  renderCompletedContactRow(item, idx, hide_closes) {
    const { user } = this.props
    let role = BROKER_CONTACT_TYPES.find(contact_type => contact_type.value == item.contact_type)
    let rowClassNames = ['UsersListRow', 'UsersList__row--' + idx % 4]
    return <tr className={rowClassNames.join(' ')} key={idx}>
      <td>
        <div className="UsersListRow__row" onClick={() => this.handleEditAdmin(item)}>
          <UsersListAvatar {...item} />
          {user.is_masquerade && <i className="fa fa-pencil"/>}
        </div>
      </td>
      <td>
        {user.is_masquerade?
          <div>
            <Select
              value={role}
              clearable={false}
              backspaceRemoves={false}
              searchable={false}
              onChange={option => this.handleAdminRoleChange(item, option.value)}
              options={BROKER_CONTACT_TYPES}
            />
          </div>
          :
          <div>{ BROKER_CONTACT_TYPES_DISPLAY[item.contact_type] }</div>
        }
        { item.email === user.broker_email ? <div className="account_contact">Account's main contact</div> : null}
      </td>
      {!hide_closes ? <td></td> : null}
      <td>
        <div>Added</div>
        <div>{moment.utc(item.created_at).local().format("MM/DD/YY h:mm A")}</div>
      </td>
      <td className="UsersListRow__actions">
        {item.email !== user.broker_email && item.username !== user.username ?
              <Button className="UsersListRow__buttons--resend UsersListRow__buttons--danger"
                      onClick={()=>{this.removeContact(item)}}>Remove Admin</Button> : null}
        {item.email === user.broker_email && item.username !== user.username ?
          <Button className="UsersListRow__buttons--resend UsersListRow__buttons--danger"
                  onClick={()=>{this.updateAndRemoveBrokerContact(item)}}>Remove Admin</Button> : null}
      </td>
    </tr>
  }

  selectTab = (tab) => {
      return () => {
        this.setState({activeTab: tab})
      }
  }

  handleSearch = _.debounce((searchTerm) => {
    const { dispatch } = this.props
    this.setState({search: searchTerm})
    dispatch(fetchAddAgent(searchTerm))
  }, 700)


  render() {
    const { isRCCOnly, completed_agents, pending_agents, completed_broker_contacts, pending_broker_contacts, completed_count, pending_count } = this.props
    const hide_closes = true
    let agents = this.state.activeTab === 'added' ? completed_agents : pending_agents
    let contacts = this.state.activeTab === 'added' ? completed_broker_contacts : pending_broker_contacts

    return (
      <div className="UsersList">
        <EditAdminModal refresh={() => this.handleSearch}/>
        <h2><i className="fa fa-users" aria-hidden="true"/>Manage Users</h2>
        <div>
            <div className={"UsersList__tab" + (this.state.activeTab === 'added' ? ' active' : '')} onClick={this.selectTab('added')}>Active Users <span>({completed_count})</span></div>
            <div className={"UsersList__tab" + (this.state.activeTab === 'pending' ? ' active' : '')} onClick={this.selectTab('pending')}>Pending Invitations <span>({pending_count})</span></div>
            <div className="UsersList__search">
              <SearchInput className="SearchInput glyphicon glyphicon-search" onChange={this.handleSearch}/>
            </div>
        </div>
        <div className="mt-20">
            <div className="UsersList__table-section">
                <Table>
                   <thead>
                      <tr>
                        <th>ADMIN</th>
                        <th>ROLE</th>
                        {this.state.activeTab === 'added' && !hide_closes ? (
                          <th>CLOSES</th>
                        ) : (
                          this.state.activeTab !== 'added' && <th>INVITES</th>
                        )}
                        { this.state.activeTab === 'added' ?
                          <th>DATE ADDED</th> : null }
                        <th>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contacts.map((item, idx) => { return this.state.activeTab === 'added' ? this.renderCompletedContactRow(item, idx, hide_closes) : this.renderPendingContactRow(item, idx) })}
                      {!contacts.length && this.state.activeTab === 'added' ?
                        <tr>
                          <td className="UsersList__empty">
                            No brokerage contacts have completed their invitation to sign up
                          </td>
                        </tr> : null}
                      {!contacts.length && this.state.activeTab === 'pending' ?
                        <tr>
                          <td className="UsersList__empty">
                            No pending invitations for brokerage contacts
                          </td>
                        </tr> : null}
                    </tbody>
                </Table>
            </div>
            <div className="UsersList__table-section">
                <Table>
                    <thead>
                      <tr>
                        <th>AGENT</th>
                        {(this.state.activeTab === 'added' || !isRCCOnly) && <th>AGENT TYPE</th>}
                        {this.state.activeTab === 'added' && !hide_closes ? (
                          <th>CLOSES</th>
                        ) : (
                          this.state.activeTab !== 'added' && <th>INVITES</th>
                        )}
                        { this.state.activeTab === 'added' ?
                          <th>DATE ADDED</th> : null }
                        <th>ACTIONS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {agents.map((item, idx) => { return this.state.activeTab === 'added' ? this.renderCompletedRow(item, idx, hide_closes) : this.renderPendingRow(item, idx, isRCCOnly) })}
                      {!agents.length && this.state.activeTab === 'added' ? <tr><td className="UsersList__empty">No agents have completed their invitation to sign up</td></tr> : null}
                      {!agents.length && this.state.activeTab === 'pending' ? <tr><td className="UsersList__empty">No pending invitations for agents</td></tr> : null}
                    </tbody>
                </Table>
            </div>
        </div>
    </div>
    )
  }
}

export class UsersListAvatar extends Component {
  render() {
    const { initials, first_name, last_name, email } = this.props
    const fullName = [first_name, last_name].join(' ').trim()

    const needsCentering = !(fullName && email)

    const nameDetails = fullName &&
              <div>{ fullName }</div>

    const emailDetails = email &&
                <div className="UsersList__small">{ email }</div>

    return <Row className="UsersListRow__details">
          <Col xs={3} sm={3} md={3}>
            <div className="avatar-circle-sm avatar-circle-sm-mt-hack">
              <span className="initials">{ initials }</span>
            </div>
          </Col>
          <Col xs={9} sm={9} md={9}>
            { needsCentering ?
              <div className="avatar-circle-sm-details-hack">
                { nameDetails }
                { emailDetails }
              </div> :
              <div>
                { nameDetails }
                { emailDetails }
              </div>
            }

          </Col>
        </Row>
  }
}

const mapStateToProps = state => ({
  completed_agents: selectCompletedAgents(state),
  pending_agents: selectPendingAgents(state),
  completed_broker_contacts: selectCompletedBrokerContacts(state),
  pending_broker_contacts: selectPendingBrokerContacts(state),
  completed_count: selectCompletedCount(state),
  pending_count: selectPendingCount(state),
  user: selectAuthUser(state),
  has_transition_product: selectHasTransitionProduct(state),
  is_mvip: selectIsMVIP(state),
  is_transition_brokerage: selectIsTransitionBrokerage(state),
  broker_hash: selectBrokerHash(state),
  allow_agent_sign_ups: selectAllowAgentSignUps(state),
})
const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(UsersList)
